import { useSaveHotelDiscover as useSaveHotelDiscoverNew } from 'app/hooks/data/core/admin/hotels/useSaveHotelDiscover';
import {
  useSaveHotelDiscover as useSaveHotelDiscoverOld, //   useSaveHotelDiscover,
} from 'app/hooks/data/hotels/useHotelDiscover';
import type { HotelDiscoverForm } from 'app/typings/hotels/Hotel/HotelDiscover';

export const useSaveHotelDiscover = ({
  hotelId,
  isLegacy,
}: {
  hotelId: number;
  isLegacy: boolean;
}) => {
  const oldMutation = useSaveHotelDiscoverOld({ hotelId });
  const newMutation = useSaveHotelDiscoverNew({ hotelId });

  // Both mutations resolve to a different `TData`, and react-query v5 types
  // `mutateAsync` with a rest tuple, which makes the union impossible to call.
  // Callers only wait for the save to complete, so the result is dropped here.
  const mutateAsync = isLegacy
    ? async (payload: HotelDiscoverForm) => {
        await oldMutation.mutateAsync(payload);
      }
    : async (payload: HotelDiscoverForm) => {
        await newMutation.mutateAsync(payload);
      };

  return {
    ...(isLegacy ? oldMutation : newMutation),
    mutateAsync,
  };
};
